import {Card} from "primereact/card";
import {fd, tt} from "../../../../shared";
import {openTab, joinCampaign} from "../../../../shared";
import {
  CampaignsGetResponse_Campaign,
  CEventLink,
  CEventLinkFlag,
  CGenre,
  CProgramHighlight
} from "../../../../apis/api-client";
import {Button} from "primereact/button";
import {t} from "i18next";
import {Tag} from "primereact/tag";

type CampaignCardProps = {
  campaign: CampaignsGetResponse_Campaign
}

export default function CampaignCard(props: CampaignCardProps) {

  const {campaign} = props;

  /**
   * Render's the campaign footer.
   * @param campaign Campaign to render footer for.
   * @returns Rendered footer.
   */
  function renderCampaignFooter(campaign: CampaignsGetResponse_Campaign) {
    return <>
      <Button
        icon='pi pi-sign-in'
        iconPos='left'
        className='flex w-full'
        label={t('7605890f-a5fd-4cf5-a7bf-d779c19e0ede')}
        onClick={
          () => {
            if (campaign.program?.id)
              joinCampaign(campaign.program?.id);
          }
        }
      />
    </>;
  }

  /**
   * Render's the campaign subtitle.
   * @param campaign Campaign to render subtitle for.
   * @returns Rendered subtitle.
   */
  function renderCampaignSubTitle(campaign: CampaignsGetResponse_Campaign) {
    return <>
      <div className='flex flex-column gap-2 h-full'>
        {
          campaign.event &&
          campaign.event?.happeningFrom &&
            <>
              {
                campaign.event?.happeningFrom === campaign.event?.happeningTo
                || (campaign.event?.happeningFrom && campaign.event.happeningTo == null)
                  ? <span><i className='pi pi-calendar'/> {fd(campaign.event?.happeningFrom!, true)}</span>
                  : <span>
                    <i className='pi pi-calendar'/> {fd(campaign.event?.happeningFrom!, false)} {campaign.event.happeningTo ? " - " + fd(campaign.event.happeningTo, false) : <></>}
                  </span>
              }
            </>
        }
        {
          campaign.event &&
          campaign.event.location &&
            <span>
              <i className='pi pi-map-marker'/> {tt(campaign.event?.id!, 'event_location', campaign.event?.location!)}
            </span>
        }
        {
          campaign.program &&
          campaign.program.highlights &&
          campaign.program.highlights.length > 0 &&
            <>
              <h4 className='mb-2'>{t('c5d8bbde-61d2-4aa5-b027-d99e72b51513')}</h4>
              <div className='flex flex-column gap-2 ml-2'>
                {
                  campaign.program &&
                  campaign.program.highlights &&
                  campaign.program.highlights.map(
                    (highlight: CProgramHighlight) => {
                      return <>
                        <span><i
                          className='pi pi-star-fill'/> {tt(highlight.id!, 'programhighlight_description', highlight.description!)}</span>
                      </>;
                    }
                  )
                }
              </div>
            </>
        }
      </div>
    </>;
  }

  /**
   * Renders the item header for the given Campaign.
   * @param campaign Campaign to render item header for.
   * @returns Rendered item header.
   */
  function renderCampaignHeader(campaign: CampaignsGetResponse_Campaign) {
    return <>
      <div
        className='flex flex-column justify-content-center align-items-center'
      >
        <div
          className='w-full mb-3'
          style={
            {
              height: '200px',
              backgroundImage: `url(${campaign.program?.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '5px'
            }
          }
        />
        <div className='flex w-full pr-3 pl-3'>
          <div
            className='flex flex-1 flex-wrap flex-row justify-content-start align-items-center'
          >
            {
              campaign.event
              && campaign.event?.genres
              && campaign.event?.genres.map(
                (genre: CGenre) => {
                  return <>
                    <Tag
                      className='m-1'
                      value={tt(genre.id!, 'genre_title', genre.title!)}
                      rounded
                    />
                  </>;
                }
              )
            }
          </div>
          <div
            className='flex flex-wrap flex-row justify-content-end align-items-center'
          >
            {
              campaign.event
              && campaign.event.links
              && campaign.event.links.map(
                (link: CEventLink) => {
                  if (link.flag && link.value) {
                    let icon: string;

                    switch (link.flag) {
                      case CEventLinkFlag.FACEBOOK:
                        icon = 'pi pi-facebook';
                        break;
                      case CEventLinkFlag.INSTAGRAM:
                        icon = 'pi pi-instagram';
                        break;
                      case CEventLinkFlag.YOUTUBE:
                        icon = 'pi pi-youtube';
                        break;
                    }

                    if (icon) {
                      return <>
                        <Button
                          icon={icon}
                          size='small'
                          onClick={
                            () => {
                              if (link.value)
                                openTab(link.value);
                            }
                          }
                          link
                        />
                      </>;
                    }
                  }
                }
              )
            }
          </div>
        </div>
      </div>
    </>;
  }

  return <>
    <Card
      className='m-2 h-full'
      title={
        tt(campaign.event?.id!, 'event_title', campaign.event?.title!)
      }
      header={renderCampaignHeader(campaign)}
      subTitle={renderCampaignSubTitle(campaign)}
      footer={renderCampaignFooter(campaign)}
    />
  </>;
}